<template>
    <v-container>
        <v-layout
        text-center
        wrap
        >
            The Idea for this page is to have a list of dental articles that are provided from us (and other professionals). This will have a component that lists each article preview
            and a 'Read More' for each one (will track views --> we may do this for treatments as well). We can then have free articles (provided once every month) and premium ones that occur
            more regularly, these will be marked with little chips.

            One of the features that are included in premium:
            -Organisations
            -Presentation Mode
            -Premium Articles
            <premium-badge :premiumInfo="getUserPremium"/>
        </v-layout>
    </v-container>
    
</template>

<script>
import PremiumBadge from './../../components/Management/PremiumEligibilityBadge.vue';

export default {
    name: 'dentalArticlePage',
    props: {
        user: Object,
    },
    components: {
        PremiumBadge
    },
    computed: {
        getUserPremium() {
            if (this.user) {
                return this.user.premium;
            }
            return false;
        }
    },
    data: () => ({

    })
}
</script>
